module.exports = __webpack_public_path__ + "static/media/gender.c04ba879.svg";